import { BaseOptionDefinition } from './base-option-definition'
import { OptionDefinition } from './option-definition'
import { OptionGroupDefinition } from './option-group-definition'

export class OptionSetModel {
  public name: string
  public options: BaseOptionDefinition[]

  constructor(optionSetModel: OptionSetModel) {
    this.name = optionSetModel.name
    this.options = optionSetModel.options.map((o) => {
      return 'options' in o ? new OptionGroupDefinition(o as OptionGroupDefinition) : new OptionDefinition(o)
    })
  }

  get allOptions(): OptionDefinition[] {
    let results: OptionDefinition[] = []
    this.options.forEach((item) => {
      if (item instanceof OptionDefinition) {
        results.push(item)
      } else {
        const group: OptionGroupDefinition = item as OptionGroupDefinition
        results = results.concat(group.options)
      }
    })
    return results
  }

  get allGroups(): OptionGroupDefinition[] {
    const results: OptionGroupDefinition[] = []
    this.options.forEach((item) => {
      if (item instanceof OptionGroupDefinition) {
        results.push(item)
      }
    })
    return results
  }

  get firstLevelOptions(): OptionDefinition[] {
    const results: OptionDefinition[] = []
    this.options.forEach((item) => {
      if (item instanceof OptionDefinition) {
        results.push(item)
      }
    })
    return results
  }
}
